module.exports = __webpack_public_path__ + "static/media/logo-white.a29b6a6d.svg";